import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ClerkProvider } from '@clerk/clerk-react';
import { enUS, esES } from '@clerk/localizations';
import { useTranslation } from 'react-i18next';

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;
const CLERK_LOCALIZATIONS = { es: esES, en: enUS };

const queryClient = new QueryClient();

export default function AppProviders({ children }) {
    const { i18n } = useTranslation();
    return (
        <ClerkProvider publishableKey={PUBLISHABLE_KEY} localization={CLERK_LOCALIZATIONS[i18n.language] ?? esES}>
            <QueryClientProvider client={queryClient}>
                <BrowserRouter>{children}</BrowserRouter>
            </QueryClientProvider>
        </ClerkProvider>
    );
}
